import React from "react";

/**
 * Suspense fallback for route chunks.
 *
 * Returns null by default so route transitions don't flash a spinner when
 * the chunk is already cached (the common case after first load). The
 * GlobalLoadingOverlay (debounced) covers genuinely slow chunk fetches.
 */
export default function RouteSuspenseFallback(_: { label?: string }) {
  return null;
}
